
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"green-leaf-bottom",attrs:{"d":"M9.702 4.449C13.83 2.69 17.574 2.903 19.42 3.2a.196.196 0 01.164.217c-.337 3.043-.787 8.357-4.986 11.753-2.74 2.216-7.167 1.485-8.086 1.303a.198.198 0 00-.228.13c-.111.328-.347 1.07-.395 1.61-.083.944.091 1.858.33 2.496.052.137-.046.291-.193.291H4.17a.195.195 0 01-.193-.152c-.105-.475-.405-1.947-.31-2.877.147-1.446.599-2.457 1.027-3.38a.193.193 0 00.018-.074c.13-2.663-.205-7.855 4.99-10.068z","fill":"var(--color-green-leaf-icon-color-bottom)"}}),_c('path',{staticClass:"green-leaf-top",attrs:{"d":"M19.438 3.203c-2.768 1.674-5.381 4.237-7.694 6.505-2.91 2.854-5.343 5.24-7.01 4.805l-.02-.038c.01-.223.018-.463.025-.717.087-2.796.225-7.291 4.963-9.31 4.141-1.763 7.895-1.544 9.736-1.245z","fill":"var(--color-green-leaf-icon-color-top)"}})])
          )
        }
      }
    